import { useState, useCallback, useEffect } from 'react';

import { AnnouncementBar } from '@/components/AnnouncementBar';
import { HeaderSubPage } from '@/components/HeaderSubPage';
import { Navbar } from '@/components/Navbar';
import { useItineraryContext } from '@/context/ItineraryContext';
import { AccommodationBlock } from '@/pages/Accommodation/AccommodationBlock';

export function AccommodationPage() {
  const { data } = useItineraryContext();
  const itineraryBlocks = data?.ItineraryBlocks;
  const [modalStates, setModalStates] = useState<{ [key: string]: boolean }>(() => {
    if (!itineraryBlocks) return {};

    const initialModalStates: { [key: string]: boolean } = {};
    itineraryBlocks.forEach((block) => {
      block.ItineraryProducts.forEach((product) => {
        if (product.name === 'Hotel') {
          initialModalStates[product.id] = false;
        }
      });
    });

    return initialModalStates;
  });

  useEffect(() => {
    console.debug('modalStates: ', modalStates);
  }, [modalStates]);

  const openModal = useCallback((productId: number) => {
    setModalStates((prev) => ({
      ...prev,
      [productId]: true,
    }));
  }, []);

  const closeModal = useCallback((productId: number) => {
    setModalStates((prev) => ({
      ...prev,
      [productId]: false,
    }));
  }, []);

  return (
    <>
      <AnnouncementBar />
      <Navbar variant="secondary" />

      <HeaderSubPage title="Your accommodations" emptyHeader />
      {itineraryBlocks?.map((block, index) => (
        <AccommodationBlock
          key={block.startDate}
          block={block}
          openModal={openModal}
          closeModal={closeModal}
          modalStates={modalStates}
          index={index}
        />
      ))}
    </>
  );
}
